module.exports = __webpack_public_path__ + "static/media/car_body.4a701c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/print/zong/car_body.png
// module id = 3313
// module chunks = 0